import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TalentHappyPathDataService } from 'src/app/talent-happy-path/shared/service/talent-happy-path-data-service';
import { Countries, TalentStatus } from 'src/app/enums';
import { getJobBoardUrl } from "../../shared/util/talent-happy-path-util";
import { Country } from "../../../gather/enums";
import { QuickApplyWorkflowService } from "../quick-apply-workflow.service";

@Component({
  selector: 'app-quick-apply-welcome',
  standalone: false,
  templateUrl: './quick-apply-welcome.component.html',
  styleUrl: './quick-apply-welcome.component.scss'
})
export class QuickApplyWelcomeComponent implements OnInit {

  talent: Talent;
  talentStatus = TalentStatus;
  jobBoardUrl: string;
  countryId: number;
  countries = Countries;

  constructor(
    private talentHappyPathDataService: TalentHappyPathDataService,
    private router: Router,
    private route: ActivatedRoute,
    private workflowService: QuickApplyWorkflowService) {
  }

  ngOnInit(): void {
      this.talent = this.talentHappyPathDataService.talent;
      this.countryId = this.talentHappyPathDataService.postingInfo.countryId;
      if (this.talent === null) {
        this.workflowService.navigateToState('submit', {} , { relativeTo: this.route.parent });
      } else {
        this.setJobBoardUrl(this.countryId);
      }
  }

  navigateToInterviewPage() {
    this.countryId = this.talentHappyPathDataService.postingInfo.countryId;
    if (this.countryId === Country.France) {
      this.router.navigateByUrl('/talent-profile', { skipLocationChange: true });
    } else {
      this.router.navigateByUrl('/initial-interview?returningCandidate=true', { skipLocationChange: true });
    }
  }

  setJobBoardUrl(countryId: number) {
    this.jobBoardUrl = getJobBoardUrl(countryId);
  }
}
